
import { defineComponent, computed, ref, Ref } from 'vue'

import useTheme from '@/composables/useTheme'

import EmailIcon from '../../assets/icons/email.svg?inline'
import EyeIcon from '../../assets/icons/eye.svg?inline'
import EyeHideIcon from '../../assets/icons/eye-slash.svg?inline'
import LockIcon from '../../assets/icons/lock.svg?inline'
import UserIcon from '../../assets/icons/user.svg?inline'

export default defineComponent({
  name: 'CardSignup',
  components: {
    EmailIcon,
    EyeIcon,
    EyeHideIcon,
    LockIcon,
    UserIcon,
  },
  setup() {
    const { currentTheme, currentMode, isLight } = useTheme()
    const password: Ref<string> = ref('')
    const showPassword: Ref<boolean> = ref(false)

    const cardClasses = computed(() => {
      const shadow = isLight.value ? 'shadow-xl' : ''

      return [currentTheme.value.bg.card, shadow]
    })

    const inputClasses = computed(() => {
      const { borders, rings } = currentTheme.value
      const { bg, placeholder } = currentTheme.value.input

      return [bg, placeholder, borders.focusPrimary, rings.focusPrimary]
    })

    const togglePassword = () => {
      showPassword.value = !showPassword.value
    }

    return {
      cardClasses,
      inputClasses,
      currentMode,
      currentTheme,
      password,
      showPassword,
      togglePassword,
    }
  },
})
